import { useState, useEffect, useCallback } from 'react';
import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';
import { SnackbarProvider } from 'contexts/SnackbarContext';
import { CompanyProvider } from 'contexts/CompanyContext';
import { BrandingProvider } from 'contexts/BrandingContext';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  const [count, setCount] = useState(0);

  const handleClick = useCallback(() => {
    console.log("Button clicked");
  }, []);
  
  return (
    <ThemeCustomization>
      <SnackbarProvider>
        <CompanyProvider>
          <BrandingProvider>
            <ScrollTop>
              <RouterProvider router={router} />
            </ScrollTop>
          </BrandingProvider>
        </CompanyProvider>
      </SnackbarProvider>
    </ThemeCustomization>
  );
}
